var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"docScroll",attrs:{"id":"widgets"}},[_c('HeaderTemplate',{attrs:{"data":_vm.contentHeader}}),_c('SectionColumn',{attrs:{"type":"full","title":"MoreTyme","content":_vm.moretyme}}),_c('SectionColumn',{attrs:{"type":"full","title":"Payflex","content":_vm.payflex}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }